import useNotifications from '@anm/hooks/useNotifications';

import { DuplicateProjectState } from '../../../../store/modules/videoFolder/types';
import config from '../../../../config';
import { AnimatronProject } from 'types/project';

const { urls } = config();

const getSuccessMessage = (project: AnimatronProject | null) => {
  const isVideo = project?.extra?.kind === 'video';
  const videoLinkSlug = `Click <a href="${urls.wave}video/${project?.id}">here</a> to open the copy`;

  return `The ${project?.extra?.kind} has been successfully duplicated. ${isVideo ? videoLinkSlug : ''}`;
};
const errorMessage = 'The has not been duplicated';

const useDuplicateProjectNotifications = (entity: DuplicateProjectState) => {
  const { notifications } = useNotifications({
    ...entity,
    errorMessage,
    successTimeout: Infinity,
    successMessage: getSuccessMessage(entity.data)
  });

  return notifications;
};

export default useDuplicateProjectNotifications;
